module.exports = __webpack_public_path__ + "static/img/Collingwood.4e3bf68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Collingwood.jpg
// module id = 3RT5
// module chunks = 1